(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-blogs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sl-blogs')) {
  customElements.define('sl-blogs', class SlBlogs extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sl-blogs__track');
      this.buttons = Array.from(this.querySelectorAll('.sl-blogs__btn'));
      if (!this.track) return;
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const card = this.track.querySelector('.sl-post');
          const step = card ? card.getBoundingClientRect().width + 20 : this.track.clientWidth * 0.8;
          this.track.scrollBy({ left: step * Number(button.dataset.dir), behavior: 'smooth' });
        });
      });
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth - 4;
        if (this.buttons[0]) this.buttons[0].disabled = this.track.scrollLeft <= 4;
        if (this.buttons[1]) this.buttons[1].disabled = this.track.scrollLeft >= max;
      };
      this.track.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      this.update();
    }
    disconnectedCallback() { window.removeEventListener('resize', this.update); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sl-hero')) {
  customElements.define('sl-hero', class SlHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.sl-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.sl-hero__dot'));
      this.index = 0;
      this.slides.forEach((slide, i) => { slide.inert = i !== 0; });
      if (this.slides.length < 2) return;

      this.delay = (parseInt(this.dataset.speed, 10) || 6) * 1000;
      this.autoplay = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.querySelectorAll('.sl-hero__arrow').forEach((button) => {
        button.addEventListener('click', () => { this.go(this.index + Number(button.dataset.dir)); this.restart(); });
      });
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.restart(); }));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      // Swipe / drag
      this.startX = null;
      this.addEventListener('pointerdown', (event) => { this.startX = event.clientX; this.swiped = false; });
      this.addEventListener('pointerup', (event) => {
        if (this.startX === null) return;
        const dx = event.clientX - this.startX;
        this.startX = null;
        if (Math.abs(dx) > 50) {
          this.swiped = true;
          this.go(this.index + (dx < 0 ? 1 : -1));
          this.restart();
        }
      });
      this.addEventListener('click', (event) => {
        if (this.swiped) { event.preventDefault(); this.swiped = false; }
      }, true);

      this.onVisibility = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this.onVisibility);

      // Preload the other slides' images once the page has loaded, so they never appear empty
      const preload = () => this.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      if (document.readyState === 'complete') preload();
      else window.addEventListener('load', preload, { once: true });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }

    go(target) {
      const count = this.slides.length;
      const next = (target + count) % count;
      if (next === this.index) return;
      const current = this.slides[this.index];
      current.classList.remove('is-active');
      current.setAttribute('aria-hidden', 'true');
      current.inert = true;
      const incoming = this.slides[next];
      incoming.classList.add('is-active');
      incoming.removeAttribute('aria-hidden');
      incoming.inert = false;
      this.dots.forEach((dot, i) => {
        if (i === next) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      this.index = next;
    }

    start() {
      if (!this.autoplay) return;
      this.stop();
      this.timer = setInterval(() => this.go(this.index + 1), this.delay);
    }

    stop() { clearInterval(this.timer); }

    restart() { this.stop(); this.start(); }
  });

  // Theme editor: show the slide that is being edited
  document.addEventListener('shopify:block:select', (event) => {
    const hero = event.target.closest && event.target.closest('sl-hero');
    if (!hero || !hero.slides) return;
    const i = hero.slides.indexOf(event.target);
    if (i > -1) { hero.stop(); hero.go(i); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-instagram"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sl-insta')) {
  customElements.define('sl-insta', class SlInsta extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sl-insta__track');
      if (!this.track) return;

      this.querySelectorAll('.sl-insta__nav button').forEach((button) => {
        button.addEventListener('click', () => {
          const card = this.track.querySelector('.sl-reel');
          const step = card ? card.getBoundingClientRect().width + 16 : this.track.clientWidth * 0.8;
          this.track.scrollBy({ left: step * Number(button.dataset.dir), behavior: 'smooth' });
        });
      });

      // Play any videos silently while they are on screen, pause them when they are not
      const videos = this.track.querySelectorAll('video');
      if (!videos.length) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      videos.forEach((video) => { video.muted = true; video.setAttribute('playsinline', ''); });
      if (reduce || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) { const p = video.play(); if (p && p.catch) p.catch(() => {}); }
          else video.pause();
        });
      }, { threshold: 0.5 });
      videos.forEach((video) => this.observer.observe(video));
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
